import type { PairListItem } from "@/lib/api/pairs";

export type TerminalMarket = "fx-cfd" | "futures";

export const FUTURES_PLATFORMS = new Set([
  "tradovate",
  "ninjatrader",
  "blackarrow",
  "tradingview",
]);

export function isFuturesPlatform(platformType: string | null | undefined): boolean {
  return FUTURES_PLATFORMS.has((platformType ?? "").toLowerCase());
}

export function isFuturesPair(pair: PairListItem): boolean {
  return (
    isFuturesPlatform(pair.longAccount.platformType) ||
    isFuturesPlatform(pair.shortAccount.platformType)
  );
}

export function terminalPath(market: TerminalMarket, slug?: string | null): string {
  const base = market === "futures" ? "/futures/terminal" : "/terminal";
  return slug ? `${base}/${encodeURIComponent(slug)}` : base;
}
